import React from 'react'
import styled from "styled-components"

const StyledLevelCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 10px;
    border: 3px solid #EEEEEE;
    padding: 20px 0;
    color: black;
    height: 100%;
`;
const StyledCardWrapper = styled.div`
    padding: 5px;
    height: ${props => props.cardHeight ? props.cardHeight : "250px"};
`;
const StyledCircle = styled.div`
    width: ${props => props.circleWidth ? props.circleWidth : "80px"};
    height: ${props => props.circleWidth ? props.circleWidth : "80px"};
    border-radius: 50%;
    font-size: 35px;
    background-color: ${props => props.bgcolor};
    color: ${props => props.textcolor};
    display: flex;
    justify-content: center;
    align-items: center;

`;
export default function ResultsCard({ bgcolor, textcolor, content, trial, children, className, cardHeight, circleWidth }) {
    return (
        <StyledCardWrapper cardHeight={cardHeight}>
            <StyledLevelCard className={className}>
                <StyledCircle bgcolor={bgcolor} textcolor={textcolor} circleWidth={circleWidth}>
                    {content}
                </StyledCircle>

                {children}
            </StyledLevelCard>

        </StyledCardWrapper>
    )
}
